import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty } from 'lodash';
import frLocale from 'date-fns/locale/fr';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import { BENEFICIARY } from 'containers/data-structure';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { DATE_PICKET_FORMAT } from 'constants/global';
import { translate } from 'containers/services/translate';
import { getAgeBeneficiary } from 'containers/PreOpeningPage/utils';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import messages from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/messages';
import {
  isReadOnly,
  beneficiaryConsistencyCheck,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { FormContainer } from 'containers/LawyerFeeNote/styled-components';
import { BENEFICIARY_OPTIONS } from 'containers/PreOpeningPage/constants';
import BeneficiaryWithCompensation from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/BeneficiaryWithNonCompensation/BeneficiaryWithCompensation';
import {
  EMPTY_BENEFICIARY_JUDGEMENT,
  BENEFICIARY_JUDGEMENT,
  CIVIL_JUDGEMENT_VICTIM_FIELDS,
  CIVIL_JUDGEMENT,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import BeneficiaryWithoutCompensation from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/BeneficiaryWithNonCompensation/BeneficiaryWithoutCompensation';

export interface BeneficiaryInfoProps {
  intl: IntlShape;
  listings: Listings;
  beneficiary: any;
  index: any;
  judgementOnMerits: any;
  isManager: boolean;
  deceasedVictimsToShow: any;
  setDeceasedVictimsToShow: Function;
  victim: any;
  showFees: any;
  setShowFees: Function;
  associatedVictims: any;
  lossDate: any;
  handleChangeBeneficiaries: Function;
  isRecap: Boolean;
  RecapInfo: any;
  beneficiaryContestationReasons: any;
  setBeneficiaryContestationReasons?: Function;
  judgement: any;
  setJudgement: Function;
  handleItemCheckBox: Function;
  isDisabled: boolean;
}
export const beneficiaryStyle = {
  width: '100%',
  marginTop: '10px',
  paddingBottom: '30px',
  paddingTop: '20px',
  paddingLeft: '20px',
  boxShadow: '0px 1px 3px #0880bc',
  borderRadius: '4px',
};
export const CheckBoxForm = (props: any) => {
  const id = `${props.victim?.id}-${props.index}`;

  return (
    <FormControlLabel
      control={
        <Checkbox
          color="primary"
          checked={get(props.judgement[id], props.type, false)}
          checkedIcon={<CheckCircle />}
          icon={<RadioButtonUnchecked />}
          disabled={props.isDisabled}
          onChange={props.handleItemCheckBox(props.type, id)}
        />
      }
      label={props.message}
    />
  );
};
const BeneficiaryInfo: React.FC<BeneficiaryInfoProps> = ({
  beneficiary,
  index,
  judgement,
  setJudgement,
  handleItemCheckBox,
  ...props
}): JSX.Element => {
  const id = `${props.victim?.id}-${index}`;

  /* istanbul ignore next */
  useEffect(() => {
    const jomBeneficiary =
      get(beneficiary, 'jomBeneficiaries', []).find(
        (item: any) =>
          item?.judgementOnMeritsId ===
          get(props.judgementOnMerits, 'judgementOnMerits.jom.id'),
      ) || {};

    const beneficiaryWithoutComp = get(
      beneficiary,
      'beneficiaryWithoutCompensation',
      {},
    );

    const civilJudgementVictimReason =
      get(props.listings, 'civilJudgementVictimReason', []).find(
        (item: any) => item.id === get(beneficiaryWithoutComp, 'reasonId'),
      ) || {};

    const currentNonCompensation = get(
      BENEFICIARY_JUDGEMENT,
      get(civilJudgementVictimReason, 'type'),
    );

    setJudgement((prevJudgement: any) => {
      const newJudgement = { ...prevJudgement };

      if (!newJudgement[id]) {
        newJudgement[id] = { ...EMPTY_BENEFICIARY_JUDGEMENT };
      }

      if (
        !isEmpty(jomBeneficiary) &&
        !get(beneficiary, 'isDeletedCompensation', false)
      ) {
        newJudgement[id][BENEFICIARY_JUDGEMENT.COMPENSATION] = true;
      }

      if (
        !isEmpty(beneficiaryWithoutComp) &&
        !beneficiaryWithoutComp.isDeleted
      ) {
        newJudgement[id][currentNonCompensation] = true;
      }

      return newJudgement;
    });
  }, [
    beneficiary,
    get(beneficiary, 'beneficiaryWithoutCompensation'),
    props.victim,
    index,
    props.judgementOnMerits,
  ]);
  /* istanbul ignore next */
  const handleChange = (victimId: number, index: number) => (
    e: React.ChangeEvent<{
      name?: string;
      value?: unknown;
    }>,
  ) => {
    const { name, value } = e.target;
    const deceasedVictims = [...props.deceasedVictimsToShow];

    const currentVictim =
      deceasedVictims.find(
        (deceasedVictim: any) => deceasedVictim.id === victimId,
      ) || {};
    const currentVictimIndex = deceasedVictims.indexOf(currentVictim);

    if (name && index !== -1) {
      if (name === BENEFICIARY.FRAIS || name === BENEFICIARY.MEDICAL_FFES)
        deceasedVictims[currentVictimIndex].beneficiaries[index][
          'isModified'
        ] = true;
      if (
        name === CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON ||
        name === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
      ) {
        deceasedVictims[currentVictimIndex].beneficiaries[index] = {
          ...deceasedVictims[currentVictimIndex].beneficiaries[index],
          isDeletedCompensation: true,
          beneficiaryWithoutCompensation: {
            ...deceasedVictims[currentVictimIndex].beneficiaries[index]
              .beneficiaryWithoutCompensation,
            isDeleted: false,
            [name]: typeof value === 'string' ? value.replace(',', '.') : value,
          },
        };
      } else {
        const beneficiaryWithoutCompensation = get(
          deceasedVictims[currentVictimIndex].beneficiaries[index],
          'beneficiaryWithoutCompensation',
          {},
        );
        deceasedVictims[currentVictimIndex].beneficiaries[index] = {
          ...deceasedVictims[currentVictimIndex].beneficiaries[index],
          isDeletedCompensation: false,
          ...(!isEmpty(beneficiaryWithoutCompensation) && {
            beneficiaryWithoutCompensation: {
              ...deceasedVictims[currentVictimIndex].beneficiaries[index]
                .beneficiaryWithoutCompensation,
              isDeleted: true,
            },
          }),
          [name]:
            typeof value === 'string'
              ? isEmpty(value)
                ? null
                : value.replace(',', '.')
              : value,
        };
      }
      props.setDeceasedVictimsToShow(deceasedVictims);
    } else {
      if (
        name === CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON ||
        name === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
      ) {
        deceasedVictims[currentVictimIndex].beneficiaries[index] = {
          ...deceasedVictims[currentVictimIndex].beneficiaries[index],
          beneficiaryWithoutCompensation: {
            [name]: typeof value === 'string' ? value.replace(',', '.') : value,
          },
        };
      } else {
        name &&
          deceasedVictims[currentVictimIndex].beneficiaries.push({
            ...(name === CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON ||
            name === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
              ? {
                  beneficiaryWithoutCompensation: {
                    [name]:
                      typeof value === 'string'
                        ? value.replace(',', '.')
                        : value,
                  },
                }
              : {
                  [name]:
                    typeof value === 'string' ? value.replace(',', '.') : value,
                }),
          });
      }
      props.setDeceasedVictimsToShow(deceasedVictims);
    }
    const beneficiaries = props.deceasedVictimsToShow
      .filter((el: any) =>
        !isEmpty(props.associatedVictims)
          ? props.associatedVictims.includes(get(el, 'id'))
          : true,
      )
      .map((deceasedVictim: any) => get(deceasedVictim, 'beneficiaries', []))
      .flat();
    props.handleChangeBeneficiaries(beneficiaries);
  };

  const handleDateChange = (victimId: number, index: number) => (
    date: Date | null,
  ) => {
    const theDate = getDateIgnoreTimezone(date);
    const dateOfBirth = moment(theDate as Date).format('YYYY-MM-DD');
    const deceasedVictims = [...props.deceasedVictimsToShow];
    const currentVictim =
      deceasedVictims.find(
        (deceasedVictim: any) => deceasedVictim.id === victimId,
      ) || {};

    const currentVictimIndex = deceasedVictims.indexOf(currentVictim);

    deceasedVictims[currentVictimIndex].beneficiaries[index] = {
      ...deceasedVictims[currentVictimIndex].beneficiaries[index],
      [BENEFICIARY.DATE_OF_BIRTH]: dateOfBirth,
      [BENEFICIARY.AGE]: String(
        getAgeBeneficiary(
          dateOfBirth,
          props.lossDate,
          get(beneficiary, [BENEFICIARY.AGE]),
        ),
      ),
    };
    props.setDeceasedVictimsToShow(deceasedVictims);
    const beneficiaries = deceasedVictims
      .filter((el: any) =>
        !isEmpty(props.associatedVictims)
          ? props.associatedVictims.includes(get(el, 'id'))
          : true,
      )
      .map((deceasedVictim: any) => get(deceasedVictim, 'beneficiaries', []))
      .flat();
    props.handleChangeBeneficiaries(beneficiaries);
  };
  return (
    <div style={beneficiaryStyle}>
      <Grid container direction="row" key={index} className="container">
        <Grid item xs={3}>
          <TextField
            label={translate({ ...messages.victimFirstName }, props)}
            name={BENEFICIARY.FIRST_NAME}
            value={get(beneficiary, [BENEFICIARY.FIRST_NAME], '')}
            onChange={handleChange(beneficiary.victimId, index)}
            className="input"
            InputProps={{
              readOnly: isReadOnly(props.judgementOnMerits, props.isManager),
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label={translate({ ...messages.victimLastName }, props)}
            name={BENEFICIARY.LAST_NAME}
            value={get(beneficiary, [BENEFICIARY.LAST_NAME], '')}
            onChange={handleChange(beneficiary.victimId, index)}
            className="input"
            InputProps={{
              readOnly: isReadOnly(props.judgementOnMerits, props.isManager),
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              format={DATE_PICKET_FORMAT}
              label={translate({ ...messages.beneficiaryBirthDate }, props)}
              name={BENEFICIARY.DATE_OF_BIRTH}
              id={BENEFICIARY.DATE_OF_BIRTH}
              value={dateStringToLocalDate(
                beneficiary[BENEFICIARY.DATE_OF_BIRTH],
              )}
              className="input"
              onChange={handleDateChange(beneficiary.victimId, index)}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={3}>
          <TextField
            name="age"
            label={translate(messages.age, props)}
            value={getAgeBeneficiary(
              get(beneficiary, [BENEFICIARY.DATE_OF_BIRTH]),
              props.lossDate,
              get(beneficiary, [BENEFICIARY.AGE]),
            )}
            onChange={handleChange(beneficiary.victimId, index)}
            className="input"
            InputProps={{
              readOnly: isReadOnly(props.judgementOnMerits, props.isManager),
            }}
            disabled
          />
        </Grid>
        <Grid item xs={3}>
          <FormControl className="input">
            <InputLabel id="demo-simple-select-outlined-label">
              {translate({ ...messages.qualityBeneficiary }, props)}
            </InputLabel>

            <Select
              className="select-field"
              name="beneficiaryType"
              value={get(beneficiary, 'beneficiaryType', '')}
              onChange={handleChange(beneficiary.victimId, index)}
              inputProps={{
                readOnly: isReadOnly(props.judgementOnMerits, props.isManager),
              }}
            >
              {!isEmpty(get(props.listings, 'qualityAyantDroit', [])) &&
                get(props.listings, 'qualityAyantDroit').map(
                  (e: SagisConfig) => (
                    <MenuItem value={e.ItemKey} key={e.ItemKey}>
                      {e.ItemDescription}
                    </MenuItem>
                  ),
                )}
            </Select>
          </FormControl>
        </Grid>
        {featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) && (
          <Grid
            item
            xs={12}
            style={{
              alignSelf: 'self-end',
              padding: '8px 0px 8px 0',
              fontWeight: 700,
            }}
          >
            <span style={{ paddingRight: '8px' }}>
              {translate({ ...messages.checkBoxTitle }, props)}
            </span>
            <CheckBoxForm
              type={BENEFICIARY_JUDGEMENT.COMPENSATION}
              handleItemCheckBox={handleItemCheckBox}
              message={translate(messages.compensationRadioLabel, props)}
              index={index}
              judgement={judgement}
              {...props}
            />
            <CheckBoxForm
              type={BENEFICIARY_JUDGEMENT.FORM_REJECTION}
              handleItemCheckBox={handleItemCheckBox}
              message={translate(messages.formRejectionRadioLabel, props)}
              index={index}
              judgement={judgement}
              {...props}
            />
            <CheckBoxForm
              type={BENEFICIARY_JUDGEMENT.SUBSTANTIVE_REJECTION}
              handleItemCheckBox={handleItemCheckBox}
              message={translate(
                messages.substantiveRejectionRadioLabel,
                props,
              )}
              index={index}
              judgement={judgement}
              {...props}
            />
          </Grid>
        )}
        {((featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
          get(judgement[id], BENEFICIARY_JUDGEMENT.COMPENSATION)) ||
          !featureService.hasFeature(
            FEATURES.REASONS_FOR_NON_COMPENSATION,
          )) && (
          <BeneficiaryWithCompensation
            beneficiary={beneficiary}
            index={index}
            deceasedVictimsToShow={props.deceasedVictimsToShow}
            setDeceasedVictimsToShow={props.setDeceasedVictimsToShow}
            setShowFuneralFees={props.setShowFees}
            showFuneralFees={props.showFees}
            associatedVictims={props.associatedVictims}
            lossDate={props.lossDate}
            handleChangeBeneficiaries={props.handleChangeBeneficiaries}
            handleChange={handleChange}
            listings={props.listings}
            isRecap={props.isRecap}
            RecapInfo={props.RecapInfo}
            beneficiaryContestationReasons={
              props.beneficiaryContestationReasons
            }
            setBeneficiaryContestationReasons={
              props.setBeneficiaryContestationReasons
            }
            victim={props.victim}
            isManager={props.isManager}
            judgementOnMerits={props.judgementOnMerits}
          />
        )}
        {featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
          get(judgement[id], BENEFICIARY_JUDGEMENT.FORM_REJECTION) && (
            <BeneficiaryWithoutCompensation
              beneficiary={beneficiary}
              index={index}
              deceasedVictimsToShow={props.deceasedVictimsToShow}
              setDeceasedVictimsToShow={props.setDeceasedVictimsToShow}
              setShowFuneralFees={props.setShowFees}
              showFuneralFees={props.showFees}
              lossDate={props.lossDate}
              handleChangeBeneficiaries={props.handleChangeBeneficiaries}
              handleChange={handleChange}
              listings={props.listings}
              victim={props.victim}
              isManager={props.isManager}
              judgementOnMerits={props.judgementOnMerits}
              mode={CIVIL_JUDGEMENT.FORM_REJECTION}
              beneficiaryWithNonCompensation={get(
                beneficiary,
                'beneficiaryWithoutCompensation',
                {},
              )}
              isNew={false}
            />
          )}
        {featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
          get(judgement[id], BENEFICIARY_JUDGEMENT.SUBSTANTIVE_REJECTION) && (
            <BeneficiaryWithoutCompensation
              beneficiary={beneficiary}
              index={index}
              deceasedVictimsToShow={props.deceasedVictimsToShow}
              setDeceasedVictimsToShow={props.setDeceasedVictimsToShow}
              setShowFuneralFees={props.setShowFees}
              showFuneralFees={props.showFees}
              lossDate={props.lossDate}
              handleChangeBeneficiaries={props.handleChangeBeneficiaries}
              handleChange={handleChange}
              listings={props.listings}
              victim={props.victim}
              isManager={props.isManager}
              judgementOnMerits={props.judgementOnMerits}
              mode={CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION}
              beneficiaryWithNonCompensation={get(
                beneficiary,
                'beneficiaryWithoutCompensation',
                {},
              )}
              isNew={false}
            />
          )}
      </Grid>
      <Grid container direction="row" key={index} className="sub-container">
        <FormContainer>
          <FormGroup>
            {get(beneficiary, [BENEFICIARY.HANDICAP_INDICATOR]) && (
              <FormControlLabel
                key={0}
                control={
                  <Checkbox
                    checked={get(
                      beneficiary,
                      [BENEFICIARY.HANDICAP_INDICATOR],
                      false,
                    )}
                    color="primary"
                    disabled
                  />
                }
                label={BENEFICIARY_OPTIONS[0]}
              />
            )}
            {get(beneficiary, [BENEFICIARY.DEPENDENT_INDICATOR]) && (
              <FormControlLabel
                key={1}
                control={
                  <Checkbox
                    checked={get(
                      beneficiary,
                      [BENEFICIARY.DEPENDENT_INDICATOR],
                      false,
                    )}
                    color="primary"
                    disabled
                  />
                }
                label={BENEFICIARY_OPTIONS[1]}
              />
            )}
          </FormGroup>
        </FormContainer>
      </Grid>
      {!beneficiaryConsistencyCheck(beneficiary) && (
        <span className="error">
          {translate({ ...messages.beneficiaryConsistencyError }, props)}
        </span>
      )}
    </div>
  );
};

export default injectIntl(BeneficiaryInfo);
